export const h = {
    "common": {
        "webSuffix": "QIDI Tech",
        "email": "Postfach",
        "password": "Passwort",
        "verificationCode": "Prüfcode",
        "username": "Benutzername",
        "readAndAgree": "Ich stimme zu",
        "and": "und",
        "userAgreement": "Nutzungsvereinbarung",
        "privacyPolicy": "Datenschutzerklärung",
        "copy": "Urheberrecht ©  Ab 2025 behält sich Di das Eigentum vor",
        "sendVerificationCode": "Bestätigungscode senden",
        "Sending": "Senden",
        "tryAgainInSeconds": "Versuchen Sie es in Sekunden erneut",
        "userNameRequired": "einen Benutzernamen eingeben",
        "passwordInputLabel": "Bitte geben Sie ein Passwort ein",
        "checkPasswordInputLabel": "Bitte geben Sie das Bestätigungs-Passwort ein",
        "userEmailRequired": "Bitte geben Sie Ihre E-Mail-Adresse ein",
        "userEmailInvalid": "Bitte geben Sie die korrekte E-Mail-Adresse ein",
        "emailCodeRequired": "Bitte geben Sie den Bestätigungscode ein",
        "newPasswordInputLabel": "Bitte geben Sie ein neues Passwort ein",
        "confirmPasswordInputLabel": "Bitte geben Sie Ihr Passwort erneut ein",
        "passwordMismatchErrorLabel": "Das zweimal eingegebene Passwort ist inkonsistent",
        "agreementRequired": "Bitte lesen und stimmen Sie der Vereinbarung zu",
        "tip": "Tipps",
        "tipAlreadyLogin": "Erkennt, dass Sie sich eingeloggt haben, zum Benutzercenter für Sie weitergeleitet",
        "tipWelcomeBack": "Willkommen zurück~",
        "tipDeleteAccountFail": "Konto konnte nicht gelöscht werden, die Benutzeroberfläche zum Löschen des Kontos wird vorübergehend geschlossen",
        "pleaseAgreeFirst": "Bitte stimmen Sie zuerst zu",
        "agree": "vereinbaren",
        "refuse": "ablehnen",
        "tipNeedLogin": "Bitte loggen Sie sich zuerst ein",
        "tipChangePasswordSuccess": "Passwort erfolgreich geändert, wir leiten Sie auf die Login-Seite weiter",
        "tipGetUserInfoSuccess": "Erfolgreich erhaltene Informationen",
        "tipGetUserInfoFail": "Informationsfehler",
        "tipLoginOut": "Abmelden und einloggen",
        "delete": "löschen",
        "back": "zurück",
        "init": "Initialisierung",

        "passwordInputLengthErrorLabel": "Die Passwortlänge sollte zwischen 6 und 20 liegen",
        "changePasswordFail": "Originalpasswort falsch",
        "tipDeleteAccountSuccess": "Konto erfolgreich gelöscht",
        "emailCodeSentSuccess": "Der Verifizierungscode wurde ausgestellt",
        "emailCodeSentFail": "Ausgabe des Verifizierungscodes fehlgeschlagen",
        "emailLoginFail": "Der Verifizierungscode ist abgelaufen",
        "passwordLoginFail": "Login Passwort falsch",
        "editUserInfoSuccess": "Erfolgreich geänderte Benutzerinformationen",
        "registerSuccess": "erfolgreich registriert",
        "registerFail": "Anmeldung fehlgeschlagen",
        "registerEmailExistFail": "E-Mail existiert bereits",

        "resMessageTip0": "unbekannte Informationen",
        "resMessageTip1": "Passwort-Fehler",
        "resMessageTip2": "Die Passwortlänge sollte zwischen 6 und 20 liegen",
        "resMessageTip3": "Kontofehler",
        "resMessageTip4": "Der Verifizierungscode wurde ausgestellt",
        "resMessageTip5": "Ausgabe des Verifizierungscodes fehlgeschlagen",
        "resMessageTip6": "Der Verifizierungscode ist abgelaufen",
        "resMessageTip7": "Passwort-Fehler",
        "resMessageTip8": "Das Passwort kann nicht mit dem alten Passwort übereinstimmen",
        "resMessageTip9": "E-Mail existiert bereits",
        "resMessageTip10": "erfolgreich registriert",
        "resMessageTip11": "Anmeldung fehlgeschlagen",
        "resMessageTip12": "Erfolgreich geänderte Benutzerinformationen",
        "resMessageTip13": "Änderung der Benutzerinformationen fehlgeschlagen",
        "resMessageTip14": "Erfolgreich erhalten",
        "resMessageTip15": "Übernahme fehlgeschlagen",
        "resMessageTip16": "Passwort erfolgreich geändert",
        "resMessageTip17": "Passwortänderung fehlgeschlagen",
        "resMessageTip18": "Passwort zurücksetzen erfolgreich",
        "resMessageTip19": "Zurücksetzen des Passworts fehlgeschlagen",
        "resMessageTip20": "Login erfolgreich",
        "resMessageTip21": "Anmeldung fehlgeschlagen",
        "resMessageTip22": "Konto erfolgreich gelöscht",
        "resMessageTip23": "Konto löschen fehlgeschlagen",
        "resMessageTip24": "Der Verifizierungscode ist falsch",
        "noUserInfoError": "Netzwerkfehler, bitte melden Sie sich erneut an"
    },
    "changePassword": {
        "newPassword": "Neues Passwort"
    },
    "deleteUser": {
        "tipDeleteUser": "Leider müssen Sie gehen. Sobald Ihr Konto gelöscht wurde, verschwinden alle Ihre persönlichen Daten dauerhaft und können nicht wiederhergestellt werden.",
        "accountDeletionTerms": "Bedingungen zur Kontolöschung"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "Passwort per E-Mail abrufen",
        "confirmPassword": "Passwort bestätigen",
        "resettingPassword": "Passwort zurücksetzen",
        "resetting": "Zurücksetzen"
    },
    "login": {
        "passwordLogin": "Passwort Login",
        "verifyLogin": "Anmeldung überprüfen",
        "accountRegistration": "Kontoregistrierung",
        "forgotPassword": "Passwort vergessen",
        "login": "Anmelden",
        "localLogin": "Lokale Anmeldung",
        "loginOut": "Abmelden",
        "continueOnYourWay": "Weiter auf dem Weg"
    },
    "register": {
        "registerAnAccount": "Registrieren Sie ein Konto",
        "register": "registrieren"
    },
    "userCenter": {
        "personalInformation": "personenbezogene Daten",
        "modifyInformation": "Informationen ändern",
        "changePassword": "Passwort ändern",
        "cancelAccount": "Konto löschen",
        "exitAccount": "Konto beenden",
        "change": "modifizieren",
        "maxCharLimitTip": "Die Länge des Benutzernamens darf 10-chinesische Schriftzeichen nicht überschreiten",
    },
    "policies": {
        "deleteAccountPrivacy": "Kontovereinbarung löschen",
        "agreement": "Nutzungsvereinbarung",
        "privacyPolicy": "Datenschutzerklärung"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Wählen Sie Ihr Land oder Ihre Region",
        "recommendedVisits": "Empfohlener Besuch",
        "NorthAmerica": "Nordamerika",
        "Europe": "Europa",
        "Asia": "Asien",
        "Other": "andere",
    }
}
export const aAndL ={
    "ar": {
        "Country": "arabisch",
        "Language": "Arabisch"
    },
    "cs": {
        "Country": "Tschechische Republik",
        "Language": "Tschechisch"
    },
    "de": {
        "Country": "Deutschland",
        "Language": "Deutsch"
    },
    "en": {
        "Country": "Britain",
        "Language": "Englisch"
    },
    "es": {
        "Country": "Spanien",
        "Language": "Spanisch"
    },
    "fr": {
        "Country": "Frankreich",
        "Language": "Französisch"
    },
    "he": {
        "Country": "Israel",
        "Language": "Hebräisch"
    },
    "hu": {
        "Country": "Ungarn",
        "Language": "Ungarische Sprache"
    },
    "it": {
        "Country": "Italien",
        "Language": "Italienisch"
    },
    "ja": {
        "Country": "Japan",
        "Language": "Japanisch"
    },
    "ko": {
        "Country": "die Republik korea",
        "Language": "Koreanisch"
    },
    "nl": {
        "Country": "Niederlande",
        "Language": "Niederländisch"
    },
    "pt": {
        "Country": "Portugal",
        "Language": "Portugiesisch"
    },
    "pt_BR": {
        "Country": "Portugal (Brasilien)",
        "Language": "Portugiesisch (Brasilien)"
    },
    "ru": {
        "Country": "Russland",
        "Language": "Russisch"
    },
    "sv": {
        "Country": "Schweden",
        "Language": "Schwedische Sprache"
    },
    "tr": {
        "Country": "Türkiye",
        "Language": "Türkisch"
    },
    "uk": {
        "Country": "Ukraine",
        "Language": "Ukrainische Sprache"
    },
    "zh": {
        "Country": "Chinesisches Festland",
        "Language": "Vereinfachtes Chinesisch"
    },
    "zh_tw": {
        "Country": "Taiwan, China",
        "Language": "Traditionelles Chinesisch"
    },
    "Canada": {
        "Country": "Kanada",
        "Language": "Englisch"
    },
    "United_States": {
        "Country": "USA",
        "Language": "Englisch"
    },
    "United_Kingdom": {
        "Country": "Britain",
        "Language": "Englisch"
    },
    "EU_Countries": {
        "Country": "EU-Länder",
        "Language": "Englisch"
    },
    "Australia": {
        "Country": "Australien",
        "Language": "Englisch"
    },
    "globalzh": {
        "Country": "Global",
        "Language": "Vereinfachtes Chinesisch"
    },
    "globalen": {
        "Country": "Global",
        "Language": "Englisch"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/de.js